(function($) {
    if ($(".collection-sidebar")) {
        //work only in collection page
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!furnitica.isSidebarAjaxClick) {
                furnitica.sidebarParams();
                var newurl = furnitica.sidebarCreateUrl();
                furnitica.sidebarGetContent(newurl);
                furnitica.reActivateSidebar();
            }
            furnitica.isSidebarAjaxClick = false;
        });
    }

    if (window.use_color_swatch || window.group_splitting) {
        $('.swatch :radio').change(function() {
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();
            $(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
        });

        // (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
        // See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options

        Shopify.optionsMap = {};

        Shopify.updateOptionsInSelector = function(selectorIndex) {

            switch (selectorIndex) {
                case 0:
                    var key = 'root';
                    var selector = $('.single-option-selector:eq(0)');
                    break;
                case 1:
                    var key = $('.single-option-selector:eq(0)').val();
                    var selector = $('.single-option-selector:eq(1)');
                    break;
                case 2:
                    var key = $('.single-option-selector:eq(0)').val();
                    key += ' / ' + $('.single-option-selector:eq(1)').val();
                    var selector = $('.single-option-selector:eq(2)');
            }

            var initialValue = selector.val();
            selector.empty();
            var availableOptions = Shopify.optionsMap[key];
            if (availableOptions && availableOptions.length) {
              for (var i = 0; i < availableOptions.length; i++) {
                  var option = availableOptions[i];
                  var newOption = $('<option></option>').val(option).html(option);
                  selector.append(newOption);
              }
              $('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
                  if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
                      $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
                  } else {
                      $(this).addClass('soldout').show().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
                  }
              });
              if ($.inArray(initialValue, availableOptions) !== -1) {
                  selector.val(initialValue);
              }
              selector.trigger('change');
            }
        };

        Shopify.linkOptionSelectors = function(product) {
            // Building our mapping object.
            for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                if (variant.available) {
                    // Gathering values for the 1st drop-down.
                    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                    Shopify.optionsMap['root'].push(variant.option1);
                    Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
                    // Gathering values for the 2nd drop-down.
                    if (product.options.length > 1) {
                        var key = variant.option1;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option2);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                    // Gathering values for the 3rd drop-down.
                    if (product.options.length === 3) {
                        var key = variant.option1 + ' / ' + variant.option2;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option3);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                }
            }
            // Update options right away.
            Shopify.updateOptionsInSelector(0);
            if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
            if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
            // When there is an update in the first dropdown.
            $(".single-option-selector:eq(0)").change(function() {
                Shopify.updateOptionsInSelector(1);
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });
            // When there is an update in the second dropdown.
            $(".single-option-selector:eq(1)").change(function() {
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });

        };
    }

    $(document).ready(function() {
        furnitica.init();
    });

    $(window).resize(function() {
        furnitica.initMobileMenu();
        furnitica.initResizeImage();
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('#back-top').fadeIn();
        } else {
            $('#back-top').fadeOut();
        }
    });
    $(document).on('click touchstart', function(e) {
      var quickview = $(".quick-view");
      var dropdowncart = $("#dropdown-cart");
      var cartButton = $("#cartToggle");
      var newsletter = $("#email-modal .modal-window");
      var dropdownAccount = $(".customer-area");
      var dropdownOtp = $('.opt-area');

      //close quickview and dropdowncart when clicking outside
      if (!dropdownOtp.is(e.target) && dropdownOtp.has(e.target).length === 0 &&  !quickview.is(e.target) && quickview.has(e.target).length === 0 && !dropdowncart.is(e.target) && dropdowncart.has(e.target).length === 0 && !cartButton.is(e.target) && cartButton.has(e.target).length === 0 && !newsletter.is(e.target) && newsletter.has(e.target).length === 0 && !dropdownAccount.is(e.target) && dropdownAccount.has(e.target).length === 0) {
        furnitica.closeQuickViewPopup();
        furnitica.closeDropdownCart();
        furnitica.closeDropdownAccount();
      }
    });
    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            furnitica.closeQuickViewPopup();
            furnitica.closeDropdownCart();
            furnitica.closeDropdownAccount();
      		furnitica.closeDropdownSearch();
            clearTimeout(furnitica.furniticaTimeout);
            if ($('.modal').is(':visible')) {
                $('.modal').fadeOut(500);
            }
        }
    });

    var furnitica = {
        furniticaTimeout: null,
        isSidebarAjaxClick: false,
        init: function() {
            this.initColorSwatchGrid();
            this.initResizeImage();
            this.initSidebar();
            this.initMobileSidebar();
          	this.initMobileMenu();
            this.initScrollTop();
            this.initQuickView();
            this.initCloudzoom();
            this.initProductMoreview();
            this.initAddToCart();
            this.initModal();
            this.initProductAddToCart();
            this.initDropDownCart();
      		this.initDropdownSearch();
            this.initToggleCollectionPanel();
            this.initWishlist();
            this.initProductWishlist();
            this.initRemoveWishlist();
            this.initInfiniteScrolling();
          	this.initScrollbar();
          	this.updateDropdownCart();
        },
        initScrollbar: function () {
//           $("/*.sidebar-links .widget-content > ul, */.sidebar-custom ul").niceScroll({
//             cursoropacitymin: 1,
//             cursorborder:"",
//             cursorwidth: "5px",
//             cursorcolor:"#5e5e5e",
//             cursorborderradius:0,
//             background: "#ebebeb"
//           });
        },
        sidebarMapTagEvents: function() {
          	$('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function(e) {
                var currentTags = [];
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }

                //one selection or multi selection
                if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
                    //remove other selection first
                    var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                    if (otherTag.length > 0) {
                        var tagName = otherTag.val();
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                //remove tag
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    }
                }

                var tagName = $(this).prev().val();
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                furnitica.sidebarAjaxClick();
                e.preventDefault();
            });
        },
        sidebarMapCategories: function() {
            $(".sidebar-links a").click(function(e) {
                if (!$(this).hasClass('active')) {
                    delete Shopify.queryParams.q;
                    furnitica.sidebarAjaxClick($(this).attr('data-href'));

                    //activate selected category
                    $(".sidebar-links a.active").removeClass("active");
                    $(this).addClass("active");
                  
                  	var par = $(this).parent();
                  	if (par.hasClass("dropdown") && !par.hasClass("click")) {
                    	$(".dropdown.click").removeClass("click");
						par.addClass("click");                  	  
                  	}
                }
                e.preventDefault();
            });
          
          	$(".sidebar-links li .caret").click(function(n)
            {
                var t = $(this).parent();
                if (t.hasClass("click"))
                {
                    t.removeClass("click");
                }
                else
                {
                    t.addClass("click");
                }              
                n.preventDefault();
            });
        },
       sidebarMapView: function() {
            $(".view-mode a").click(function(e) {
                if (!$(this).hasClass("active")) {
                    var paging = $(".filter-show > button span").text();
                    if ($(this).hasClass("list")) {
                        Shopify.queryParams.view = "list" + paging;
                    } else {
                        Shopify.queryParams.view = paging;
                    }

                    furnitica.sidebarAjaxClick();
                    $(".view-mode a.active").removeClass("active");
                    $(this).addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarMapShow: function() {
            $(".filter-show a").click(function(e) {
                if (!$(this).parent().hasClass("active")) {
                    var thisPaging = $(this).attr('href');

                    var view = $(".view-mode a.active").attr("href");
                    if (view == "list") {
                        Shopify.queryParams.view = "list" + thisPaging;
                    } else {
                        Shopify.queryParams.view = thisPaging;
                    }

                    furnitica.sidebarAjaxClick();
                    $(".filter-show > button span").text(thisPaging);
                    $(".filter-show li.active").removeClass("active");
                    $(this).parent().addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarViewMode: function(){
          $(".view-mode a.grid").click(function(e) {
            $('.view-mode a.list').removeClass('active');
            $(this).addClass('active');
            if($('.product-collection').hasClass('product-list')){
                $('.product-collection').addClass('products-grid-covert');
            }
            else if($('.product-collection').hasClass('products-grid')){
              $('.product-collection').removeClass('products-list-covert');
            }
          });

          $(".view-mode a.list").click(function(e) {
            $('.view-mode a.grid').removeClass('active');
            $(this).addClass('active');   
            if($('.product-collection').hasClass('products-grid')){
                $('.product-collection').addClass('products-list-covert');
            }
            else if($('.product-collection').hasClass('product-list')){
              $('.product-collection').removeClass('products-grid-covert');
            }
          });
        },
        sidebarInitToggle: function() {
            if ($(".sidebar-tag").length > 0) {
                $(".sidebar-tag .widget-title span").click(function() {
                    var $title = $(this).parents('.widget-title');
                    if ($title.hasClass('click')) {
                        $title.removeClass('click');
                    } else {
                        $title.addClass('click');
                    }

                    $(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
                });
            }
            if ($(".sidebar-links").length > 0) {
                $('.sidebar-links ul.cat-dropdown a').parents(".dropdown").removeClass("click");  
              	//$('.sidebar-links a.active').parents('.dropdown').addClass("click");
                $('.sidebar-links a.active').parents(".dropdown").addClass("click").find("ul.cat-dropdown").show();
                //$('.sidebar-links a.active').parent().addClass("click").find("ul.dropdown-cat").show();
            }
        },
        sidebarMapSorting: function(e) {
            $(".filter-sortby a").click(function(e) {
                if (!$(this).parent().hasClass("active")) {
                    Shopify.queryParams.sort_by = $(this).attr("href");
                    furnitica.sidebarAjaxClick();
                    var sortbyText = $(this).text();
                    $(".filter-sortby > button span").text(sortbyText);
                    $(".filter-sortby li.active").removeClass("active");
                    $(this).parent().addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarMapPaging: function() {
            $(".pagination-page a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if (page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = furnitica.sidebarCreateUrl();
                        furnitica.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        furnitica.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            scrollTop: 500
                        }, 600);
                    }
                }
                e.preventDefault();
            });
        },
        sidebarMapClearAll: function() {
            //clear all selection
            $('.refined-widgets a.clear-all').click(function(e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;
                furnitica.sidebarAjaxClick();
                e.preventDefault();
            });
        },
        ClearSelected: function(){
              $('.selected-tag a').click(function(e) {
                  var currentTags = [];
                  if (Shopify.queryParams.constraint) {
                      currentTags = Shopify.queryParams.constraint.split('+');
                  }

                  //one selection or multi selection
                  if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
                      //remove other selection first
                      var otherTag = $(this).parents('.selected-tag').find("input:checked");
                      if (otherTag.length > 0) {
                          var tagName = otherTag.val();
                          if (tagName) {
                              var tagPos = currentTags.indexOf(tagName);
                              if (tagPos >= 0) {
                                  //remove tag
                                  currentTags.splice(tagPos, 1);
                              }
                          }
                      }
                  }

                  var tagName = $(this).prev().val();
                  if (tagName) {
                      var tagPos = currentTags.indexOf(tagName);
                      if (tagPos >= 0) {
                          //tag already existed, remove tag
                          currentTags.splice(tagPos, 1);
                      } else {
                          //tag not existed
                          currentTags.push(tagName);
                      }
                  }
                  if (currentTags.length) {
                      Shopify.queryParams.constraint = currentTags.join('+');
                  } else {
                      delete Shopify.queryParams.constraint;
                  }
                  furnitica.sidebarAjaxClick();
                  e.preventDefault();
              });
        },
        sidebarMapClear: function() {
            $(".sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if (sidebarTag.find("input:checked").length > 0) {
                    //has active tag
                    sidebarTag.find(".clear").show().click(function(e) {
                        var currentTags = [];
                        if (Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if (currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
						furnitica.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        },
        sidebarMapEvents: function() {
            furnitica.sidebarMapTagEvents();
            furnitica.sidebarMapCategories();
           furnitica.sidebarMapView();
            furnitica.sidebarMapShow();
          
      		//furnitica.sidebarViewMode();
            furnitica.sidebarMapSorting();
        },
        reActivateSidebar: function() {
            $(".sidebar-custom .active, .sidebar-links .active").removeClass("active");
            $(".sidebar-tag input:checked").attr("checked", false);

            //category
            var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
            if (cat && cat[1]) {
                $(".sidebar-links a[data-href='" + cat[0] + "']").addClass("active");
            }

            //view mode and show filter
            if (Shopify.queryParams.view) {
                $(".view-mode .active").removeClass("active");
                var view = Shopify.queryParams.view;
                if (view.indexOf("list") >= 0) {
                    $(".view-mode .list").addClass("active");
                    //paging
                    view = view.replace("list", "");
                } else {
                    $(".view-mode .grid").addClass("active");
                }
                $(".filter-show > button span.number").text(view);
                $(".filter-show li.active").removeClass("active");
                $(".filter-show a[href='" + view + "']").parent().addClass("active");
            }
            furnitica.initSortby();
        },
        initSortby: function() {
            //sort by filter
            if (Shopify.queryParams.sort_by) {
                var sortby = Shopify.queryParams.sort_by;
                var sortbyText = $(".filter-sortby a[href='" + sortby + "']").text();
                $(".filter-sortby > button span").text(sortbyText);
                $(".filter-sortby li.active").removeClass("active");
                $(".filter-sortby a[href='" + sortby + "']").parent().addClass("active");
            }
        },
        sidebarMapData: function(data) {
            var currentList = $(".col-main .products-grid");
            if (currentList.length == 0) {
                currentList = $(".col-main .product-list");
            }
            var productList = $(data).find(".col-main .products-grid");
            if (productList.length == 0) {
                productList = $(data).find(".col-main .product-list");
            }
            if (productList.length > 0 && productList.hasClass("products-grid")) {
                if (window.product_image_resize) {
                    productList.find('img').fakecrop({
                        fill: window.images_size.is_crop,
                        widthSelector: ".products-grid .grid-item .product-image",
                        ratioWrapper: window.images_size
                    });
                }
            }
            currentList.replaceWith(productList);
            //convert currency
            if (furnitica.checkNeedToConvertCurrency()) {
                Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '.col-main span.money', 'money_format');
            }

            //replace paging
            if ($(".padding").length > 0) {
                $(".padding").replaceWith($(data).find(".padding"));
            } else {
                $(".block-row.col-main").append($(data).find(".padding"));
            }
          
            // page top
          	if ($(".padding_top").length > 0) {
                $(".padding_top").replaceWith($(data).find(".padding_top"));
            } else {
                $(".block-row.col-main .product-collection.products-grid").before($(data).find(".padding_top"));
            }
            //replace title & description
            var currentHeader = $(".page-header");
            var dataHeader = $(data).find(".page-header");
            if (currentHeader.find("h3").text() != dataHeader.find("h3").text()) {
                currentHeader.find("h3").replaceWith(dataHeader.find("h3"));
              
                var currentDes = $(".collection-des");
                var dataDes = $(data).find(".collection-des");
              
                if (currentDes.find(".rte").length) {
                    if (dataDes.find(".rte").length) {
                        currentDes.html(dataDes.find(".rte"));
                    } else {
                        currentDes.find(".rte").hide();
                    }
                } else {
                    currentDes.html(dataDes.find(".rte"));
                }
              
                var currentImg = $(".collection-img");
                var dataImg = $(data).find(".collection-img");
                if (currentImg.find("p").length) {
                    if (dataImg.find("p").length) {
                        currentImg.html(dataImg.find("p"));
                    } else {
                        currentImg.find("p").hide();
                    }
                } else {
                    currentImg.html(dataImg.find("p"));
                }
            }

            //replace refined
            $(".refined-widgets").replaceWith($(data).find(".refined-widgets"));
            
            //replace tags
            $(".sidebar-block").replaceWith($(data).find(".sidebar-block"));
          
            //breadcrumb
           $(".breadcrumb .br_title").replaceWith($(data).find(".breadcrumb .br_title"));
          
            furnitica.initColorSwatchGrid();
          
            //product review
            if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
        },
        sidebarCreateUrl: function(baseLink) {
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }
            return location.pathname + "?" + newQuery;
        },
        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = furnitica.sidebarCreateUrl(baseLink);
            furnitica.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            furnitica.sidebarGetContent(newurl);
        },
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    furnitica.showLoading();
                },
                success: function(data) {
                    furnitica.sidebarMapData(data);
                    furnitica.sidebarMapPaging();
                    furnitica.translateBlock(".main-content");
                    furnitica.sidebarMapTagEvents();
                    furnitica.sidebarInitToggle();
                    furnitica.sidebarMapClear();
                    furnitica.sidebarMapClearAll();
                    furnitica.ClearSelected();
                    furnitica.hideLoading();
					
                    furnitica.initQuickView();
                    furnitica.initAddToCart();
                    furnitica.initWishlist();
                    furnitica.initInfiniteScrolling();
                    furnitica.initScrollbar();
                  	
                },
                error: function(xhr, text) {
                    furnitica.hideLoading();
                    $('.loading-modal').hide();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    furnitica.showModal('.ajax-error-modal');
                }
            });
        },
        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
        initMobileSidebar: function() {
            //if ($(".header-mobile").is(":visible")) {
            $('footer').append("<a class='option-sidebar left' id='displayTextLeft' href='javascript:void(0)' title='Show Sidebar'><span>Show Sidebar</span></a>");
            $('#displayTextLeft').click(
                function(event) {
                    event.preventDefault();
                    if ($('.sidebar').is(":hidden")) {
                        //jQuery('.col-main').fadeOut(800);
                        $('.sidebar').fadeIn(800);
                        $('body,html').animate({
                            scrollTop: 200
                        }, 600);
                        $('#displayTextLeft').toggleClass('hidden-arrow-left');
                        $('#displayTextLeft').attr('title', 'hide-sidebar');
                        $('#displayTextLeft').html('<span>Hide Sidebar</span>');
                    } else {
                        $('.sidebar').fadeOut(800);
                        $('#displayTextLeft').removeClass('hidden-arrow-left');
                        $('#displayTextLeft').attr('title', 'show-sidebar');
                        $('#displayTextLeft').html('<span>Show Sidebar</span>');
                        //jQuery('.col-main').fadeIn(800);
                    }
                });
            //}
        },
        initSidebar: function() {
            //if category page then init sidebar
            if ($(".collection-sidebar").length > 0) {
                furnitica.sidebarParams();
                furnitica.initSortby();
                furnitica.sidebarMapEvents();
                furnitica.sidebarMapPaging();
                furnitica.sidebarInitToggle();
                furnitica.sidebarMapClear();
                furnitica.sidebarMapClearAll();
                furnitica.ClearSelected();
            }
          
          	$(".sidebar-links.no-ajax li .caret").click(function(n)
            {
                var t = $(this).parent();
                if (t.hasClass("click"))
                {
                    t.removeClass("click");
                }
                else
                {
                    t.addClass("click");
                }              
                n.preventDefault();
            });
        },
        initMobileMenu: function() {
            if ($(".menu-block").is(':visible')) {
                $(".gf-menu-device-container ul.gf-menu li.dropdown").each(function() {
                    if ($(this).find("> p.toogleClick").length == 0) {
                        $(this).prepend('<p class="toogleClick">+</p>');
                    }
                });
        
                if ($(".menu-block").children().hasClass("gf-menu-device-wrapper") == false) {
                    $(".menu-block").children().addClass("gf-menu-device-wrapper");
                }
                if ($(".gf-menu-device-container").find("ul.gf-menu").length == 0) {
                    $(".gf-menu-device-container").append($(".nav-bar .container").html());
                    $(".gf-menu-device-container .site-nav").addClass("gf-menu");
                    $(".gf-menu-device-container .site-nav").removeClass("nav")
                }
                $("p.toogleClick").click(function() {
                    if ($(this).hasClass("mobile-toggle-open")) {
                        $(this).next().next().hide();
                        $(this).removeClass("mobile-toggle-open");
                    } else {
                        $(this).next().next().show();
                        $(this).addClass("mobile-toggle-open")
                    }
                });
                var w = window.innerWidth;
                if (w < 1024) {
                    jQuery('.site-nav .dropdown .menu__moblie').bind('click', function(event) {
                        if (currentEl != this) {
                            $(this).next().show();
                            $(this).prev().addClass('mobile-toggle-open');
                            event.preventDefault();
                            currentEl = this;
                        }
                    });
                }
                $("p.toogleClick").show();
                $("div.gf-menu-toggle").hide();
                $(".nav-bar .container").hide();
                if ($("ul.gf-menu").hasClass("clicked") == false) {
                    $(".gf-menu").hide();
                    $(".gf-menu li.dropdown ul.site-nav-dropdown").hide();
                }
        
                $(".col-1 .inner ul.dropdown").parent().each(function() {
                    if ($(this).find("> p.toogleClick").length == 0) {
                        $(this).prepend('<p class="toogleClick">+</p>');
                    }
                });
        
                $(".cbp-spmenu span.icon-dropdown").remove();
        
                $("ul.gf-menu li.dropdown").each(function() {
                    if ($(this).find("> p.toogleClick").length == 0) {
                        $(this).prepend('<p class="toogleClick">+</p>');
                    }
                });
        
                $("p.toogleClick").click(function() {
                    if ($(this).hasClass("mobile-toggle-open")) {
                        $(this).next().next().hide();
                        $(this).removeClass("mobile-toggle-open");
                        $(this).text('+');
                    } else {
                        $(this).next().next().show();
                        $(this).addClass("mobile-toggle-open");
                        $(this).text('-');
                    }
                });
        
            } else {
                $(".nav-bar .container").show();
                $(".gf-menu").hide();
            }
            if ($(".menu-block").children().hasClass("gf-menu-device-wrapper") == false) {
                $(".menu-block").children().addClass("resized");
            }
            if ($('.header-mobile').is(':visible')) {
                $('.lang-block').appendTo(jQuery('.opt-area'));
                $('.currency').appendTo(jQuery('.opt-area'));
            } else {
                $('.lang-block').prependTo(jQuery('.right-header-top'));
                $('.currency').prependTo(jQuery('.right-header-top'));
            }
        },

        //opt header

        closeDropdownOpt: function() {
            $(".add-cart-success-wrapper").addClass('empty');
          if ($('.opt-area .dropdown-menu').is(':visible')) {
            $('.opt-area .dropdown-menu').slideUp('fast');
          }
        },

        initDropdownOpt: function() {
          if ($('.header-mobile').is(':visible')) {
            $('.lang-block').appendTo(jQuery('.opt-area .dropdown-menu'));
            $('.currency').appendTo(jQuery('.opt-area .dropdown-menu'));
            $('.opt-area .fa-cog').click(function(){                
              if ($('.opt-area .dropdown-menu').is(':visible')) {
                $('.opt-area .dropdown-menu').slideUp('fast');
              } else {
                $('.opt-area .dropdown-menu').slideDown('fast');
              }
            })
          } else {
            $('.lang-block').appendTo(jQuery('.header-panel-top .container'));
            $('.currency').appendTo(jQuery('.header-panel-top .container'));
          }

          $('.opt-area .fa-cog').click(function(){
            furnitica.closeDropdownCart();
          })


          $('#cartToggle').click(function(){
            $(".add-cart-success-wrapper").addClass('empty');
            furnitica.closeDropdownOpt();
          })
        },
        closeDropdownAccount: function() {
            if ($('.customer-area').hasClass('open')) {
                $('.customer-area').removeClass('open');
            }
        },
        initDropdownAccount: function() {
            if ($('.header-mobile').is(':visible')) {
                $('.lang-block').appendTo(jQuery('.customer-area .dropdown'));
                $('.currency').appendTo(jQuery('.customer-area .dropdown'));
            } else {
              	$('.lang-block').prependTo(jQuery('.header-panel .pull-left'));
                $('.currency').prependTo(jQuery('.header-panel .pull-left'));
            }
          
            $('.customer-area > a').click(function(){              
                if ($(this).parent().hasClass('open')) {
                    $(this).parent().removeClass('open');
                } else {
                    $(this).parent().addClass('open');
                }
            })

            $('#cartToggle').click(function(){
                $(".add-cart-success-wrapper").addClass('empty');
                furnitica.closeDropdownAccount();
            });
        },
        initWishlist: function() {
            $('.grid-item button.wishlist').click(function(e) {
                e.preventDefault();
                var form = $(this).parent();
                var item = form.parents('.grid-item');
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        furnitica.showLoading();
                    },
                    success: function(data) {
                        furnitica.hideLoading();
                        form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        var title = item.find('.product-title').html();
                        var image = item.find('a > img').attr('src');
                        $('.ajax-success-modal').find('.ajax-product-title').html(title);
                        $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                        $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
                        $('.ajax-success-modal').find('.btn-go-to-cart').hide();
                        furnitica.showModal('.ajax-success-modal');
                    },
                    error: function(xhr, text) {
                        furnitica.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        furnitica.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initProductWishlist: function() {
            $('.product button.wishlist').click(function(e) {
                e.preventDefault();
                var form = $(this).parent();
                var item = form.parents('.grid-item');
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        furnitica.showLoading();
                    },
                    success: function(data) {
                        furnitica.hideLoading();
                        form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        var title = $('.product-title h2').html();
                        var image = $('#product-featured-image').attr('src');
                        $('.ajax-success-modal').find('.ajax-product-title').html(title);
                        $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                        $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
                        $('.ajax-success-modal').find('.btn-go-to-cart').hide();
                        furnitica.showModal('.ajax-success-modal');
                    },
                    error: function(xhr, text) {
                        furnitica.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        furnitica.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initRemoveWishlist: function() {
            $('.btn-remove-wishlist').click(function(e) {
                var row = $(this).parents('tr');
                var tagID = row.find('.tag-id').val();
                var form = jQuery('#remove-wishlist-form');
                form.find("input[name='contact[tags]']").val('x' + tagID);
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        furnitica.showLoading();
                    },
                    success: function(data) {
                        furnitica.hideLoading();
                        row.fadeOut(1000);
                    },
                    error: function(xhr, text) {
                        furnitica.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        furnitica.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initColorSwatchGrid: function() { 
          jQuery('.item-swatch li label').hover(function(){
            var newImage = jQuery(this).parent().find('.hidden a').attr('href');
            jQuery(this).parents('.grid-item').find('.product-grid-image img').attr({ src: newImage }); 
            return false;
          });
        },
        initResizeImage: function() {
            if (window.product_image_resize) {
                $('.products-grid .product-image img').fakecrop({
                    fill: window.images_size.is_crop,
                    widthSelector: ".products-grid .grid-item .product-image",
                    ratioWrapper: window.images_size
                });
            }
        },
        initInfiniteScrolling: function() {
            if ($('.infinite-scrolling').length > 0) {
                $('.infinite-scrolling a').click(function(e) {
                    e.preventDefault();
                    if (!$(this).hasClass('disabled')) {
                        furnitica.doInfiniteScrolling();
                    }
                });
            }
        },
        doInfiniteScrolling: function() {
            var currentList = $('.block-row .products-grid');
            if (!currentList.length) {
                currentList = $('.block-row .product-list');
            }
            if (currentList) {
                var showMoreButton = $('.infinite-scrolling a').first();
                $.ajax({
                    type: 'GET',
                    url: showMoreButton.attr("href"),
                    beforeSend: function() {
                        furnitica.showLoading();
                        $('.loading-modal').show();
                    },
                    success: function(data) {
                        furnitica.hideLoading();
                        var products = $(data).find(".block-row .products-grid");
                        if (!products.length) {
                            products = $(data).find(".block-row .product-list");
                        }
                        if (products.length) {
                            if (products.hasClass('products-grid')) {
                                /*fake crop*/
                                if (window.product_image_resize) {
                                    products.children().find('img').fakecrop({
                                        fill: window.images_size.is_crop,
                                        widthSelector: ".products-grid .grid-item .product-image",
                                        ratioWrapper: window.images_size
                                    });
                                }
                            }

                            currentList.append(products.children());
                            furnitica.translateBlock("." + currentList.attr("class"));
                            furnitica.initQuickView();
                            furnitica.initAddToCart();
                            furnitica.initWishlist();
                            //get link of Show more
                            if ($(data).find('.infinite-scrolling').length > 0) {
                                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
                            } else {
                                //no more products
                                showMoreButton.hide();
                                showMoreButton.next().show();
                            }
                          
                          	//currency
                            if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                            }
                          
                            furnitica.initColorSwatchGrid();
                          
                            //product review
                            if ($(".spr-badge").length > 0) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            }
                        }
                    },
                    error: function(xhr, text) {
                        furnitica.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        furnitica.showModal('.ajax-error-modal');
                    },
                    dataType: "html"
                });
            }
        },
        closeEmailModalWindow: function() {
            if ($('#email-modal').length > 0 && $('#email-modal').is(':visible')) {
                $('#email-modal .modal-window').fadeOut(600, function() {
                    $('#email-modal .modal-overlay').fadeOut(600, function() {
                        $('#email-modal').hide();
                        Cookies.set('emailSubcribeModal', 'closed', {
                            expires: 1,
                            path: '/'
                        });
                    });
                });
            }
        },
        showModal: function(selector) {
            $(selector).fadeIn(500)
            furnitica.furniticaTimeout = setTimeout(function() {
                $(selector).fadeOut(500);
            }, 5000);
        },
        initToggleCollectionPanel: function() {
            if ($('.collection-sharing-btn').length > 0) {
                $('.collection-sharing-btn').click(function() {
                    $('.collection-sharing-panel').toggle();
                    if ($('.collection-sharing-panel').is(':visible')) {
                        $('.collection-sharing-btn').addClass('btn-hover');
                        $('.collection-filter-panel').hide();
                        $('.collection-filter-btn').removeClass('btn-hover');
                    } else {
                        $('.collection-sharing-btn').removeClass('btn-hover');
                    }
                });
            }
            if ($('.collection-filter-btn').length > 0) {
                $('.collection-filter-btn').click(function() {
                    $('.collection-filter-panel').toggle();
                    if ($('.collection-filter-panel').is(':visible')) {
                        $('.collection-filter-btn').addClass('btn-hover');
                        $('.collection-sharing-panel').hide();
                        $('.collection-sharing-btn').removeClass('btn-hover');
                    } else {
                        $('.collection-filter-btn').removeClass('btn-hover');
                    }
                });
                $('.collection-filter-panel select').change(function(index) {
                    window.location = $(this).find('option:selected').val();
                });
            }
        },
        checkItemsInDropdownCart: function() {
            if ($('#dropdown-cart .mini-products-list').children().length > 0) {
                //Has item in dropdown cart
                $('#dropdown-cart .no-items').hide();
                $('#dropdown-cart .has-items').show();
            } else {
                //No item in dropdown cart                
                $('#dropdown-cart .has-items').hide();
                $('#dropdown-cart .no-items').show();
            }
        },
        initModal: function() {
            $('.continue-shopping').click(function() {
                clearTimeout(furnitica.furniticaTimeout);
                $('.ajax-success-modal').fadeOut(500);
            });
            $('.close-modal, .overlay').click(function() {
                clearTimeout(furnitica.furniticaTimeout);
                $('.ajax-success-modal').fadeOut(500);
            });
        },
        closeDropdownCart: function() {
            if ($('#dropdown-cart').is(':visible')) {
                $("#dropdown-cart").slideUp('fast');
            }
        },
        initDropDownCart: function() {
            if (window.dropdowncart_type == "click") {
                //click type  
                $('#cartToggle').click(function() {
                $(".add-cart-success-wrapper").addClass('empty');
                    if ($('#dropdown-cart').is(':visible')) {
                        $("#dropdown-cart").slideUp('fast');
                    } else {
                        $("#dropdown-cart").slideDown('fast');
                    }
                });
            } else {
                //hover type
                if (!('ontouchstart' in document)) {
                    $('#cartToggle').hover(function() {
                        if (!$('#dropdown-cart').is(':visible')) {
                            $("#dropdown-cart").slideDown('fast');
                        }
                    });
                    $('.wrapper-top-cart').mouseleave(function() {
                        $("#dropdown-cart").slideUp('fast');
                    });
                } else {
                    //mobile
                    $('#cartToggle').click(function() {
                        $(".add-cart-success-wrapper").addClass('empty');
                        if ($('#dropdown-cart').is(':visible')) {
                            $("#dropdown-cart").slideUp('fast');
                        } else {
                            $("#dropdown-cart").slideDown('fast');
                        }
                    });
                }
            }

            furnitica.checkItemsInDropdownCart();

            $('#dropdown-cart .no-items a').click(function() {
                $("#dropdown-cart").slideUp('fast');
            });

            $('.continue-link').click(function() {
                $("#dropdown-cart").slideUp('fast');
            });

            $('#dropdown-cart .btn-remove').click(function(event) {
                event.preventDefault();
                var productId = $(this).parents('.item').attr('id');
                productId = productId.match(/\d+/g);
                Shopify.removeItem(productId, function(cart) {
                    furnitica.doUpdateDropdownCart(cart);
                });
            });

            $('#loginTrigger').click(function(){
                furnitica.closeDropdownCart();
            });
            $('.customer-links #loginTrigger').click(function(){
                furnitica.closeDropdownCart();
            });
        },
        initDropdownSearch: function() {
          $('.have-fixed .nav-search .icon-search').click(function() {
            if ($('.have-fixed .nav-search .search-bar').is(':visible')) {
              $('.have-fixed .nav-search .search-bar').slideUp('fast');
            } else {
              $('.have-fixed .nav-search .search-bar').slideDown('fast');
            }
          });
        },
        closeDropdownSearch: function() {
          if ($(".nav-search .search-bar").is(":visible")) {
            $(".nav-search .search-bar").slideUp("fast");
          }
        },
        initProductMoreview: function() {
            if ($('.more-view.horizontal').length > 0) {
                this.initOwlMoreview();
            } else if ($('.more-view.vertical').length > 0) {
                this.initJcarouselMoreview();
            }
        },
        initOwlMoreview: function() {  
            $('.more-view.horizontal ul').owlCarousel({
                pagination: false,
                navigation: true,
              	items : 5,
                itemsDesktop: [1199, 5],
                itemsDesktopSmall: [979, 4],
                itemsTablet: [767, 4],
                itemsTabletSmall: [540, 5],
                itemsMobile: [450, 4]
            });
        },
        initJcarouselMoreview: function() {
            $('.more-view.vertical ul').jcarousel({
                vertical: true
            });
            if ($("#product-featured-image").length > 0) {
              var height_moreview = $("#product-featured-image").height();
              $('.more-view.vertical').css('height',height_moreview + 'px');
            }
        },
        initCloudzoom: function() {
            if ($("#product-featured-image").length > 0) {
                if ($(".visible-phone").is(":visible")) {
                    //mobile display
                    $("#product-featured-image").elevateZoom({
                        gallery: 'more-view-carousel',
                        cursor: 'pointer',
                        galleryActiveClass: 'active',
                        imageCrossfade: false,
                        scrollZoom: false,
                        onImageSwapComplete: function() {
                            $(".zoomWrapper div").hide();
                        },
                        loadingIcon: window.loading_url
                    });
                    $("#product-featured-image").bind("click", function(e) {
                        return false;
                    });
                } else {
                    $("#product-featured-image").elevateZoom({
                        gallery: 'more-view-carousel',
                        cursor: 'pointer',
                        galleryActiveClass: 'active',
                        imageCrossfade: true,
                        scrollZoom: true,
                        onImageSwapComplete: function() {
                            $(".zoomWrapper div").hide();
                        },
                        loadingIcon: window.loading_url
                    });

                    $("#product-featured-image").bind("click", function(e) {
                        var ez = $('#product-featured-image').data('elevateZoom');
                        $.fancybox(ez.getGalleryList());
                        return false;
                    });
                }
            }
        },
        initScrollTop: function() {
            $('#back-top').click(function() {
                $('body,html').animate({
                    scrollTop: 0
                }, 400);
                return false;
            });
        },
        initProductAddToCart: function() {
            if ($('#product-add-to-cart').length > 0) {
                $('#product-add-to-cart').click(function(event) {
                    event.preventDefault();
                    if ($(this).attr('disabled') != 'disabled') {
                        if (!window.ajax_cart) {
                            $(this).closest('form').submit();
                        } else {
                            var variant_id = $('#add-to-cart-form select[name=id]').val();
                            if (!variant_id) {
                                variant_id = $('#add-to-cart-form input[name=id]').val();
                            }
                            var quantity = $('#add-to-cart-form input[name=quantity]').val();
                            if (!quantity) {
                                quantity = 1;
                            }
                            var title = $('.product-title h3').html();
                            var image = $('#product-featured-image').attr('src');
                            furnitica.doAjaxAddToCart(variant_id, quantity, title, image);
                        }
                    }
                    return false;
                });
            }
        },
        initAddToCart: function() {
            if ($('.add-to-cart-btn').length > 0) {
                $('.add-to-cart-btn').click(function(event) {
                    event.preventDefault();
                    if ($(this).attr('disabled') != 'disabled') {
                        var productItem = $(this).parents('.product-item');
                        var productId = $(productItem).attr('id');
                        productId = productId.match(/\d+/g);
                        if (!window.ajax_cart) {
                            $('#product-actions-' + productId).submit();
                          	
                        } else {
                            var variant_id = $('#product-actions-' + productId + ' select[name=id]').val();
                            if (!variant_id) {
                                variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
                            }
                            var quantity = $('#product-actions-' + productId + ' input[name=quantity]').val();
                            if (!quantity) {
                                quantity = 1;
                            }
                            var title = $(productItem).find('.product-title').html();
                            var image = $(productItem).find('.product-grid-image img').attr('src');
                            furnitica.doAjaxAddToCart(variant_id, quantity, title, image);
                          	
                        }
                    }
                    return false;
                });
            }
        },
      ErrorCheckout: function(){
        var text = $('.wrapper-top-cart #dropdown-cart .summary .price .money').text();
		var number = text.match(/\d/g);
        number = number.join("");
        alert (number);
      },
        showLoading: function() {
            $('.loading-modal').show();
        },
        hideLoading: function() {
            $('.loading-modal').hide();
        },
        doAjaxAddToCart: function(variant_id, quantity, title, image) {
            console.log(variant_id);
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: 'quantity=' + quantity + '&id=' + variant_id,
                dataType: 'json',
                beforeSend: function() {
                    if (variant_id != undefined) {
                        furnitica.showLoading();
                    }
                },
                success: function(msg) {
                    furnitica.hideLoading();
                    $('.ajax-success-modal').find('.ajax-product-title').html(furnitica.translateText(title));
                    $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                    $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
                    $('.ajax-success-modal').find('.btn-go-to-cart').show();
                    $(".add-cart-success-wrapper.empty").removeClass('empty');

                    $(".add-cart-success").text('Item added to your cart');
                    $("#dropdown-cart").css('display', 'block');
                    furnitica.showModal('.ajax-success-modal');
                    furnitica.updateDropdownCart();
                },
                error: function(xhr, text) {
                    furnitica.hideLoading();
                    // $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    // furnitica.showModal('.ajax-error-modal');
                }
            });
        },
        initQuickView: function() {
            $('.quickview-button a').click(function() {
                var product_handle = $(this).attr('id');
                Shopify.getProduct(product_handle, function(product) {
                    var template = $('#quickview-template').html();
                    $('.quick-view').html(template);
                    var quickview = $('.quick-view');

                    quickview.find('.product-title a').html(furnitica.translateText(product.title));
                    quickview.find('.product-title a').attr('href', product.url);
                    if (quickview.find('.sample-vendor > span').length > 0) {
                        quickview.find('.sample-vendor > span').text(product.vendor);
                    }
                    if (quickview.find('.product-vendor > span').length > 0) {
                        quickview.find('.product-vendor > span').text(product.vendor);
                    }
                    if (quickview.find('.product-type > span').length > 0) {
                        quickview.find('.product-type > span').text(product.type);
                    }
                    if (quickview.find('.product-inventory > span').length > 0) {
                      var variant = product.variants[0];
                      var inventoryInfo = quickview.find('.product-inventory > span');                      
                      if (variant.available) {
                        if (variant.inventory_management!=null) {
                          inventoryInfo.text(window.inventory_text.in_stock);
                        } else {
                          inventoryInfo.text(window.inventory_text.many_in_stock);
                        }
                      } else {
                        inventoryInfo.text(window.inventory_text.out_of_stock);
                      }
                    }
                    //countdown for quickview
                    
 					if(product.description != null) {
                    if (product.description.indexOf("[countdown]") > 0) {
                        var countdownTime = product.description.match(/\[countdown\](.*)\[\/countdown\]/);
                        if (countdownTime && countdownTime.length > 0) {
                            quickview.find(".countdown").show();
                            quickview.find(".quickview-clock").countdown(countdownTime[1], function(event) {
                                $(this).html(event.strftime('%Dd %H:%M:%S'));
                            });
                        }
                    }else{quickview.find('.countdown').remove();}
                    if (quickview.find('.short-description').length > 0) {
                        var ahihi = product.description.replace(/(<([^>]+)>)/ig, "");
                        var ahoho = ahihi.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
                        var description = ahoho.replace(/\[custom-tab\](.*)([^>]+)(.*)\[\/custom-tab\]/g, "");
                        if (window.multi_lang) {
                          if (description.indexOf("[lang2]") > 0) {
                            var descList = description.split("[lang2]");
                            if (jQuery.cookie("language") != null) {
                                description = descList[translator.current_lang - 1];
                            } else {
                                description = descList[0];
                            }
                          }
                        }
                        description = description.split(" ").splice(0, 30).join(" ") + "...";
                        quickview.find('.short-description').text(description);
                    } else {
                        quickview.find('.short-description').remove();
                    }
                  }

                    quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
                    quickview.find('.product-item').attr('id', 'product-' + product.id);
                    quickview.find('.variants').attr('id', 'product-actions-' + product.id);
                  
                  quickview.find('.product-img-box').attr('id', 'product-' + product.id);
                  
                    quickview.find('.variants select').attr('id', 'product-select-' + product.id);
                  
                  // review
                  	var in_fo = $('#product-'+ product.id +' .spr-badge').html();
          	 		$('#product-'+ product.id +' .re_view').html(in_fo);
					
                   // Sold Out 
                  

                  	var in_fo = $('#product-'+ product.id +' .product-label').html();
          	 		$('#product-'+ product.id +' .product-label-qiuck').html(in_fo);
                  
                  
                    //if has compare price
                    if (product.compare_at_price > product.price) {
                        quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                        quickview.find('.price').addClass('on-sale');
                    } else {
                        quickview.find('.compare-price').remove();
                        quickview.find('.price').removeClass('on-sale');
                    }

                    //out of stock
                    if (!product.available) {
                        quickview.find("select, input, .total-price, .dec, .inc, .variants label, .extra").remove();
                        quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass('disabled').attr("disabled", "disabled");;
                    } else {
                        quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));
                        if (window.use_color_swatch || window.group_splitting) {
                            furnitica.createQuickViewVariantsSwatch(product, quickview);
                        } else {
                            furnitica.createQuickViewVariants(product, quickview);
                        }
                    }

                    //quantity
                    quickview.find(".button").on("click", function() {
                        var oldValue = quickview.find(".quantity").val(),
                            newVal = 1;
                        if ($(this).text() == "+") {
                            newVal = parseInt(oldValue) + 1;
                        } else if (oldValue > 1) {
                            newVal = parseInt(oldValue) - 1;
                        }
                        quickview.find(".quantity").val(newVal);

                        if (quickview.find(".total-price").length > 0) {
                            furnitica.updatePricingQuickview();
                        }
                    });

                    if (window.show_multiple_currencies) {
                        Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), 'span.money', 'money_format');
                    }

                    furnitica.loadQuickViewSlider(product, quickview);
                    furnitica.initQuickviewAddToCart();
                    furnitica.translateBlock(".quick-view");

                    $('.quick-view').fadeIn(500);
                    if ($('.quick-view .total-price').length > 0) {
                        $('.quick-view input[name=quantity]').on('change', furnitica.updatePricingQuickview);
                    }
                });

                return false;
            });

            $(document).on("click", ".quick-view .overlay, .close-window", function() {
                furnitica.closeQuickViewPopup();
                return false;
            });
        },
        updatePricingQuickview: function() {
            //try pattern one before pattern 2
            var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var unitPriceTextMatch = $('.quick-view .price').text().match(regex);

            if (!unitPriceTextMatch) {
                regex = /([0-9]+[.|,][0-9]+)/g;
                unitPriceTextMatch = $('.quick-view .price').text().match(regex);
            }

            if (unitPriceTextMatch) {
                var unitPriceText = unitPriceTextMatch[0];
                var unitPrice = unitPriceText.replace(/[.|,]/g, '');
                var quantity = parseInt($('.quick-view input[name=quantity]').val());
                var totalPrice = unitPrice * quantity;

                var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
                regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
                if (!totalPriceText.match(regex)) {
                   regex = /([0-9]+[.|,][0-9]+)/g;
                } 
                totalPriceText = totalPriceText.match(regex)[0];

                var regInput = new RegExp(unitPriceText, "g");
                var totalPriceHtml = $('.quick-view .price').html().replace(regInput, totalPriceText);

                $('.quick-view .total-price span').html(totalPriceHtml);
            }
        },
        initQuickviewAddToCart: function() {
            if ($('.quick-view .add-to-cart-btn').length > 0) {
                $('.quick-view .add-to-cart-btn').click(function() {
                  	
                    var variant_id = $('.quick-view select[name=id]').val();
                    if (!variant_id) {
                        variant_id = $('.quick-view input[name=id]').val();
                    }
                    var quantity = $('.quick-view input[name=quantity]').val();
                    if (!quantity) {
                        quantity = 1;
                    }

                    var title = $('.quick-view .product-title a').html();
                    var image = $('.quick-view .quickview-featured-image img').attr('src');
                    furnitica.doAjaxAddToCart(variant_id, quantity, title, image);
                  	furnitica.ErrorCheckout;
                    furnitica.closeQuickViewPopup();
                });
            }
        },
        updateDropdownCart: function() {
            Shopify.getCart(function(cart) {
                furnitica.doUpdateDropdownCart(cart);
            });
        },
        doUpdateDropdownCart: function(cart) {
            var template = `<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><svg width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <rect width="15" height="15" fill="url(#pattern0-minicart)"></rect>
            <defs>
            <pattern id="pattern0-minicart" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlink:href="#image0_60_758" transform="scale(0.00444444)"></use>
            </pattern>
            <image id="image0_60_758" width="225" height="225" xlink:href="data:image/png;base64,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"></image>
            </defs>
          </svg></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="product-option">
          <dt>{VARIANTTITLE}{SEMI}</dt>
          <dd>{VARIANTVALUE}</dd>
        </div><div class="product-option">
          <dt>{VARIANTTITLE2}{SEMI2}</dt>
          <dd>{VARIANTVALUE2}</dd>
        </div>
        <div class="cart-collateral"><span class="price">{PRICE}</span> x {QUANTITY}</div></div></li>`;

          
          var template2 = `<li class="item" id="{ID}">{SETID}<a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove offer-product"><svg width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <rect width="15" height="15" fill="url(#pattern0-minicart)"></rect>
            <defs>
            <pattern id="pattern0-minicart" patternContentUnits="objectBoundingBox" width="1" height="1">
            <use xlink:href="#image0_60_758" transform="scale(0.00444444)"></use>
            </pattern>
            <image id="image0_60_758" width="225" height="225" xlink:href="data:image/png;base64,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"></image>
            </defs>
          </svg></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="product-option">
          <ul class="properties">
            {PROPERTIES}
        </ul>
        </div>
        <div class="cart-collateral"><span class="price">{PRICE}</span> x {QUANTITY}</div></div></li>`;

            $('#cartCount').text(cart.item_count);
          window.cart_json = cart;
            /*Total price*/
          $('#dropdown-cart .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));

        //   if(cart.total_price < 25000){
        //     $('#dropdown-cart .actions button').hide();
        //     $('#dropdown-cart .actions a.error-checkout-button').show();
        //   }
        //   else{
        //     $('#dropdown-cart .actions button').show();
        //     $('#dropdown-cart .actions a.error-checkout-button').hide();
        //   }         
            /*Clear cart*/
            $('#dropdown-cart .mini-products-list').html('');
            /*Add product to cart*/
            if (cart.item_count > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    var item = template2;
                    var cartItem = cart.items[i];
                    var propertiesHtml = '';
                    var productUrl='';
                    var productImage='';
                    var productName='';
                    var productPrice='';
                    var setId='';

                    // Check for line item properties and modify the product name, image, price, and URL if they exist
                    if (cartItem.properties && Object.keys(cartItem.properties).length > 0) {
                        for (var key in cartItem.properties) {
                            if (cartItem.properties.hasOwnProperty(key)) {
                                var propertyValue = cartItem.properties[key];
                                switch (key) {
                                    case 'Offer':
                                        hasOfferProperty = true;
                                        productName = propertyValue;
                                        break;
                                    case 'Price':
                                        productPrice = parseFloat(propertyValue); // Assuming property value is in dollars and needs to be converted to cents
                                        break;
                                    case 'Image':
                                        productImage = propertyValue;
                                        break;
                                    case 'PageUrl':
                                        productUrl = propertyValue;
                                        break;
                                }
                                // Append property to propertiesHtml
                                
                            }
                        }
                        var count = 1;
                        for (var i = 0; i < cart.items.length; i++) {
                            var cartItem = cart.items[i];
                            if (cartItem.properties && Object.keys(cartItem.properties).length > 0) {
                        propertiesHtml += `<li><strong>Item ${count}:</strong> ${furnitica.translateText(cart.items[i].title)}</li>`;
                        setId += `<span class="remove-offer-products" id=cart-item-${cartItem.key}></span>`;
                        count++;
                            }
                        }
                        // // Include the real product title in the properties
                    // propertiesHtml += `<li><strong>Real Title:</strong> ${furnitica.translateText(cart.items[i].title)}</li>`;

                    // Replace basic item details
                    item = item.replace(/\{ID\}/g, cartItem.key);
                    item = item.replace(/\{URL\}/g, productUrl);
                    item = item.replace(/\{TITLE\}/g, furnitica.translateText(productName));
                    item = item.replace(/\{QUANTITY\}/g, cartItem.quantity);

                    // Replace image and price details
                    item = item.replace(/\{IMAGE\}/g, productImage);
                    item = item.replace(/\{PRICE\}/g, '₹'+ productPrice);

                    // Replace properties
                    item = item.replace(/\{PROPERTIES\}/g, propertiesHtml);
                    item = item.replace(/\{SETID\}/g, setId);

                    // Append the item to the dropdown cart
                    $('#dropdown-cart .mini-products-list').append(item);
                    } 
                     
                }

                    
                }
                for (var i = 0; i < cart.items.length; i++) {
                    var cartItem = cart.items[i];
                    if (cartItem.properties && Object.keys(cartItem.properties).length > 0) {
                        continue; // Skip this item
                    }
                    var item = template;
                    var cartItem = cart.items[i];
                    console.log('cartItem.properties');
                    console.log(cartItem.properties);
                        console.log('testiing');
                    item = item.replace(/\{ID\}/g, cart.items[i].id);
                    item = item.replace(/\{URL\}/g, cart.items[i].url);
                    item = item.replace(/\{TITLE\}/g, furnitica.translateText(cart.items[i].title));
                    item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
                    var variants = cart.items[i].options_with_values;
                    // Assuming you want to access the first variant
                    if (variants.length > 0) {
                        console.log(variants);
                        if (variants[0].value != 'Default Title') {
                            item = item.replace(/\{VARIANTTITLE\}/g, variants[0].name);
                            item = item.replace(/\{VARIANTVALUE\}/g, variants[0].value);
                            item = item.replace(/\{SEMI\}/g, ':');
                        }else {
                            item = item.replace(/\{VARIANTTITLE\}/g, '');
                            item = item.replace(/\{VARIANTVALUE\}/g, '');
                            item = item.replace(/\{SEMI\}/g, '');
                        }
                        if (variants[1]) {
                            console.log('inner');
                            if (variants[1].value != 'Default Title') {
                                item = item.replace(/\{VARIANTTITLE2\}/g, variants[1].name);
                                item = item.replace(/\{VARIANTVALUE2\}/g, variants[1].value);
                                item = item.replace(/\{SEMI2\}/g, ':');
                            }
                        } else {
                            console.log('else');
                            item = item.replace(/\{VARIANTTITLE2\}/g, '');
                            item = item.replace(/\{VARIANTVALUE2\}/g, '');
                            item = item.replace(/\{SEMI2\}/g, '');
                        }
                   
                    }
                    item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
                item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
                $('#dropdown-cart .mini-products-list').append(item);
                }

                $('#dropdown-cart .btn-remove').click(function(event) {
                    event.preventDefault();
                    $(".add-cart-success-wrapper").addClass('empty');
                    var productId = $(this).parents('.item').attr('id');
                    if ($(this).hasClass('offer-product')) {
                        var itemsToRemove = $('#dropdown-cart .remove-offer-products');
                        var linesToRemove = [];
                        var formData = new FormData();
                        // Extract the line items from the elements
                        itemsToRemove.each(function() {
                            var line = $(this).attr('id').match(/\d+/g);
                            
                            // Ensure the line item is properly captured
                            if (line && line.length > 0) {
                                linesToRemove.push(line[0]); // Assuming the line item is in the format we need
                            } else {
                                console.error('Failed to extract line item from:', $(this).attr('id'));
                            }
                            formData.append('updates[' + line + ']', 0);
                        });
                        console.log(formData);
                        console.log('formData');
                        
                    // After appending all updates, send a single fetch request to update the cart
                            fetch('/cart/update.js', {
                                method: 'POST',
                                body: formData
                            })
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error('Network response was not ok');
                                }
                                return response.json(); // Parse the JSON response
                            })
                            .then(data => {
                                fetch(`/discount/EXTRA5`, {
                                    method: 'GET',
                                }).then(response => {
                                    // Make a request to retrieve the current cart
                                      // Make a request to retrieve the current cart
                                        fetch('/cart.js', {
                                            method: 'GET',
                                            headers: {
                                            'Content-Type': 'application/json'
                                            }
                                        })
                                        .then(response => {
                                            if (!response.ok) {
                                            throw new Error('Network response was not ok');
                                            }
                                            return response.json();
                                        })
                                        .then(data => {
                                            // Check if cart items exist
                                            if (data && data.items) {
                                            // Access the cart items and log their length
                                            console.log('Number of items in cart:', data.items.length);
                                            furnitica.doUpdateDropdownCart(data);

                                            } else {
                                            console.log('Cart is empty');
                                            }
                                        })
                                        .catch(error => {
                                            console.error('Error fetching cart:', error);
                                        });
                                })
                            });
                        // // Function to remove an item from the cart
                        // const removeItem = (line) => {
                        //     return $.ajax({
                        //         type: 'POST',
                        //         url: '/cart/change.js',
                        //         dataType: 'json',
                        //         data: JSON.stringify({
                        //             quantity: 0,
                        //             id: line
                        //         }),
                        //         contentType: 'application/json',
                        //         success: function (data) {
                        //             console.log('Item removed:', line, data);
                        //         },
                        //         error: function (jqXHR, textStatus, errorThrown) {
                        //             console.error('Failed to remove item:', line, textStatus, errorThrown);
                        //         }
                        //     });
                        // };
                    
                        // // Remove each item by line
                        // Promise.all(linesToRemove.map(line => removeItem(line)))
                        //     .then(results => {
                        //         console.log('Items removed successfully:', results);
                        //     })
                        //     .catch(error => {
                        //         console.error('Error removing items:', error);
                        //         alert('There was an error removing items. Please try again.');
                        //     });
                    } else {
                        productId = productId.match(/\d+/g);
                        Shopify.removeItem(productId, function(cart) {
                            furnitica.doUpdateDropdownCart(cart);
                        });
                    }
                   
                });
                // $('#dropdown-cart .btn-remove.offer-product').click(function(event) {
                //     event.preventDefault();
                //     $(".add-cart-success-wrapper").addClass('empty');
                //     // Select the elements containing the keys of the items to remove
                //     var itemsToRemove = $('#dropdown-cart .remove-offer-products');
                //     var linesToRemove = [];
        
                //     // Extract the line items from the elements
                //     itemsToRemove.each(function() {
                //         var line = $(this).attr('id').match(/\d+/g);
                        
                //         // Ensure the line item is properly captured
                //         if (line && line.length > 0) {
                //             linesToRemove.push(line[0]); // Assuming the line item is in the format we need
                //         } else {
                //             console.error('Failed to extract line item from:', $(this).attr('id'));
                //         }
                //     });
        
                //     // Function to remove an item from the cart
                //     const removeItem = (line) => {
                //         return fetch('/cart/change.js', {
                //             method: 'POST',
                //             headers: {
                //                 'Content-Type': 'application/json',
                //                 'Accept': 'application/json'
                //             },
                //             body: JSON.stringify({
                //                 line: parseInt(line), // Convert line to integer as required by the API
                //                 quantity: 0
                //             })
                //         }).then(response => response.json());
                //     };
        
                //     // Remove each item by line
                //     Promise.all(linesToRemove.map(line => removeItem(line)))
                //         .then(results => {
                //             console.log('Items removed', results);
                //         })
                //         .catch(error => {
                //             console.error('Error removing items:', error);
                //             alert('There was an error removing items. Please try again.');
                //         });
                  
                // });
                if (furnitica.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '#dropdown-cart span.money', 'money_format');
                }
            furnitica.checkItemsInDropdownCart();
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
        },
        loadQuickViewSlider: function(product, quickviewTemplate) {
          var featuredImage = Shopify.resizeImage(product.featured_image, 'grande');
          quickviewTemplate.find('.quickview-featured-image').append('<a href="' + product.url + '"><img src="' + featuredImage + '" title="' + product.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
// 		  quickviewTemplate.find('.rating').attr('data-id', product.id);
          quickviewTemplate.find('.product-label strong.new').append(product.tags);
            if (product.images.length > 1) {
                var quickViewCarousel = quickviewTemplate.find('.quick-view-more-view ul');
                var count = 0;
                for (i in product.images) {
                  if (count < product.images.length) {
                    var grande = Shopify.resizeImage(product.images[i], 'grande');
                    var compact = Shopify.resizeImage(product.images[i], 'compact');
                    var item = '<li><a href="javascript:void(0)" data-image="' + grande + '"><img src="' + compact + '"  /></a></li>'

                    quickViewCarousel.append(item);
                    count = count + 1;
                  }
                }

                quickViewCarousel.find('a').click(function() {
                    var quickViewFeatureImage = quickviewTemplate.find('.quickview-featured-image img');
                    var quickViewFeatureLoading = quickviewTemplate.find('.quickview-featured-image div');
                    if (quickViewFeatureImage.attr('src') != $(this).attr('data-image')) {
                        quickViewFeatureImage.attr('src', $(this).attr('data-image'));
                        quickViewFeatureLoading.show();
                        quickViewFeatureImage.load(function(e) {
                            quickViewFeatureLoading.hide();
                            $(this).unbind('load');
                            quickViewFeatureLoading.hide();
                        });
                    }
                });
                if (quickViewCarousel.parent().hasClass("horizontal")) {
                    furnitica.initQuickViewCarousel(quickViewCarousel);
                } else {
                    furnitica.initQuickViewVerticalMoreview(quickViewCarousel);
                }
            } else {
                quickviewTemplate.find('.quickview-more-views').remove();
            }

        },
        initQuickViewCarousel: function(quickViewCarousel) {
            if (quickViewCarousel) {
                quickViewCarousel.owlCarousel({
                    pagination: false,
                    navigation: true,
                    items: 5,
                    itemsDesktop: [1199, 4],
                    itemsDesktopSmall: [979, 3],
                    itemsTablet: [768, 3],
                    itemsTabletSmall: [540, 3],
                    itemsMobile: [360, 3]
                });
            }
        },
        initQuickViewVerticalMoreview: function(quickViewCarousel) {
            if (quickViewCarousel) {
                if (jQuery(".quick-view-more-view.vertical ul").children().length > 3) {
                  jQuery(".quick-view-more-view").niceScroll({
                    cursoropacitymin: 1,
                    cursorborder:"",
                    cursorwidth: "5px",
                    cursorcolor:"#d2d2d2",
                    cursorborderradius:0,
                    background: "#ebebeb"
                  });
                }
              
                $('.product-img-box').addClass('has-jcarousel');
            }
        },
        convertToSlug: function(text) {
            return text
                .toLowerCase()
                .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');
        },
        createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
            if (product.variants.length > 1) { //multiple variants
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                    quickviewTemplate.find('form.variants > select').append(option);
                }
                new Shopify.OptionSelectors("product-select-" + product.id, {
                    product: product,
                    onVariantSelected: selectCallbackQuickview
                });

                //start of quickview variant;
                var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
                var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
                var options = "";
                for (var i = 0; i < product.options.length; i++) {
                    options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                    options += '<div class="header">' + product.options[i].name + '<span>*</span></div>';
                    var is_color = false;
                    if (/Color|Colour/i.test(product.options[i].name)) {
                        is_color = true;
                    }
                    var optionValues = new Array();
                    for (var j = 0; j < product.variants.length; j++) {
                        var variant = product.variants[j];
                        var value = variant.options[i];
                        var valueHandle = this.convertToSlug(value);
                        var forText = 'swatch-' + i + '-' + valueHandle;
                        if (optionValues.indexOf(value) < 0) {
                            //not yet inserted
                            options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

                            if (is_color) {
                                options += '<div class="tooltip">' + value + '</div>';
                            }
                            options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

                            if (is_color) {
                                options += '<label for="' + forText + '" style="background-color: ' + valueHandle + '; background-image: url(' + filePath + valueHandle + '.png)"><img class="crossed-out" src="' + assetUrl +'" /></label>';
                            } else {
                                options += '<label for="' + forText + '">' + value + '<img class="crossed-out" src="' + assetUrl + '" /></label>';
                            }
                            options += '</div>';
                            if (variant.available) {
                                $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                            }
                            optionValues.push(value);
                        }
                    }
                    options += '</div>';
                }
                quickviewTemplate.find('form.variants > select').after(options);
                quickviewTemplate.find('.swatch :radio').change(function() {
                    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                    var optionValue = $(this).val();
                    $(this)
                        .closest('form')
                        .find('.single-option-selector')
                        .eq(optionIndex)
                        .val(optionValue)
                        .trigger('change');
                });
                if (product.available) {
                    Shopify.optionsMap = {};
                    Shopify.linkOptionSelectors(product);
                }

                //end of quickview variant
            } else { //single variant
                quickviewTemplate.find('form.variants > select').remove();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
            }
        },
        createQuickViewVariants: function(product, quickviewTemplate) {
            if (product.variants.length > 1) { //multiple variants
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                    quickviewTemplate.find('form.variants > select').append(option);
                }

                new Shopify.OptionSelectors("product-select-" + product.id, {
                    product: product,
                    onVariantSelected: selectCallbackQuickview
                });
                $('.quick-view .single-option-selector').selectize();
                $('.quick-view .selectize-input input').attr("disabled", "disabled");

                if (product.options.length == 1) {
                    $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
                }
                quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
                    $(this).html(product.options[i].name);
                });
            } else { //single variant
                quickviewTemplate.find('form.variants > select').remove();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
            }

        },
        closeQuickViewPopup: function() {
            $('.quick-view').fadeOut(500);
        },
        translateText: function(str) {
          if (!window.multi_lang || str.indexOf("|") < 0)
            return str;

          if (window.multi_lang) {
            var textArr = str.split("|");
            if (translator.isLang2())
              return textArr[1];
            return textArr[0];
          }          
        },
      translateBlock: function(blockSelector) {
          if (window.multi_lang && translator.isLang2()) {
          translator.doTranslate(blockSelector);
        }
      }
    }
//     $('a').on('click touchend', function(e) {
// var el = $(this);
// var link = el.attr('href');
// window.location = link;
//});
})(jQuery);
$( window ).resize(function() {
      if ($("#product-featured-image").length > 0) {
        var height_moreview = $("#product-featured-image").height();
        $('.more-view.vertical').css('height',height_moreview + 'px');
      }
})
